import { colorPalette } from '../../../colorPalette';
export const content = {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '2px 4px',
    boxSizing: 'border-box',
    backgroundColor: colorPalette.gray100,
    fontWeight: 600,
    fontSize: '10px',
    color: colorPalette.gray500,
    borderRadius: '2px',
    textTransform: 'uppercase',
};
